import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@Services/redux/Store';
import { NotificationType } from './Interfaces';
import { initialNotificationState } from './State';

const NotificationSlice = createSlice({
    name: 'Notification',
    initialState: initialNotificationState,
    reducers: {
        addNotification: (state, action) => {
            state.notifications.unshift(action.payload);
        },
        removeNotification: (state, action) => {
            const idx = state.notifications.findIndex(
                (n) => n.id === action.payload
            );
            state.notifications.splice(idx, 1);
        },
        updateNotification: (state, action) => {
            const idx = state.notifications.findIndex(
                (n) => n.id === action.payload.id
            );
            state.notifications[idx] = action.payload;
        },
        setHasUnreadNotifications: (state) => {
            state.hasUnreadNotifications = true;
        },
        setAllNotificationsRead: (state) => {
            state.hasUnreadNotifications = false;
        },
        removeProcessNotifications: (state) => {
            state.notifications = state.notifications.filter(
                (n) => n.type !== NotificationType.PROGRESS
            );
        },
    },
});

export const NotificationActions = NotificationSlice.actions;

export const notificationsState = (state: RootState) =>
    state.notification.notifications;
export const hasUnreadNotificationsState = (state: RootState) =>
    state.notification.hasUnreadNotifications;

export default NotificationSlice.reducer;
